import { render, staticRenderFns } from "./SelectorManager.vue?vue&type=template&id=63eda15c&"
import script from "./SelectorManager.vue?vue&type=script&lang=ts&"
export * from "./SelectorManager.vue?vue&type=script&lang=ts&"
import style0 from "./SelectorManager.vue?vue&type=style&index=0&id=63eda15c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports